<div class="ui-checkbox-group">
  <div class="ui-checkbox-header">
    <label>{{ label }}</label>
    <app-ui-tooltip *ngIf="tooltipText.length > 0" size="small" [content]="tooltipText"></app-ui-tooltip>
  </div>
  <ng-content></ng-content>
  <div *ngIf="hasError" class="ui-checkbox-error">
    <p><i class="icon-i-close-circle"></i>{{ errorMessage }}</p>
  </div>
</div>
